import { Box, Card, Typography } from '@mui/material'
import React from 'react'
import image from '../../../../assest/images/Good team-pana.png'

const WelcomeCard = ({ employeeData }) => {
    return (
        <Card
            sx={{
                position: "relative",
                display: "flex",
                flexDirection: "row",
                justifyContent: "space-between",
                bgcolor: "#E2E4F1",
                borderRadius: "16px",
                p: 2,
                boxShadow: "none",
                width: "100%",
                height: '150px',
                zIndex: 1
            }}
        >
            <Box sx={{
                flexShrink: 0,
                position: "absolute",
                left: 16,
                top: '50%',
                transform: "translateY(-50%)",
            }}>
                <img
                    src={image}
                    alt="image not found"
                    style={{
                        width: "370px",
                        height: "360px",
                        borderRadius: "12px",
                        objectFit: 'contain',
                        marginTop: '50px',
                        marginBottom: '-100px'
                    }}
                />
            </Box>

            <Box sx={{
                display: "flex",
                flexDirection: "column",
                alignItems: "flex-end",
                marginLeft: 'auto',
                justifyContent: "center",
                height: "100%",
                textAlign: 'center',
            }}>
                <Typography variant='h4' color='dark' fontWeight='bold' sx={{ marginRight: '80px', fontStyle: 'italic', fontFamily: '"Dancing Script", cursive' }}>
                    Hi {employeeData?.employee_name},
                </Typography>
                <Typography variant='caption' color='dark' sx={{ marginTop: '5px' }}>"Welcome to your dashboard –<br/> track, manage, and achieve your goals with ease!"</Typography>
            </Box>
        </Card>

    )
}

export default WelcomeCard
